<template >
  <div>
    <v-overlay :value="overlay || $store.state.loading_pdf">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <div>
      <div class="formPosition">
        <v-card style="margin:auto;" width="1240">
          <v-card-title style="background-color:#006699;color:white;"></v-card-title>
          <v-data-table :headers="headers" :items="dados" :search="searchInDb" sort-by="data_" class="elevation-3">
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-row>
                  <v-col md="12">
                    <v-toolbar-title>Bancos (Detalhado) </v-toolbar-title>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col md="3">
                    <v-select v-model="bancoSelected" :rules="ruleRequired" item-value="pk_banco" item-text="nome" :items="bancos" chips label="Selecione o banco" return-object></v-select>
                  </v-col>
                  <v-col md="3">
                    <v-menu ref="menu" v-model="menu" :close-on-content-click="false" :return-value.sync="date" transition="scale-transition" offset-y min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="date" label="Seleciona a data inicial" readonly v-bind="attrs" v-on="on"></v-text-field>
                      </template>
                      <v-date-picker v-model="date" no-title scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu = false"> Cancel </v-btn>
                        <v-btn text color="primary" @click="$refs.menu.save(date)"> OK </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col md="3">
                    <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" :return-value.sync="date2" transition="scale-transition" offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="date2" label="Seleciona a data final" readonly v-bind="attrs" v-on="on"></v-text-field>
                      </template>
                      <v-date-picker v-model="date2" no-title scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu = false"> Cancel </v-btn>
                        <v-btn text color="primary" @click="$refs.menu2.save(date2)"> OK </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col md="1">
                    <v-btn small fab color="green" @click="getVendas()" style="color:white;" :disabled="bancoSelected.pk_banco === 0"><v-icon>search</v-icon></v-btn>
                  </v-col>
                  <v-col md="1" v-if="dados.length">
                    <v-btn small fab color="primary" @click="gerarHTML()"><v-icon>print</v-icon></v-btn>
                  </v-col>
                </v-row>
              </v-toolbar>
            </template>
            <template v-slot:item.ordem="{ item }">
              <span>{{ dados.indexOf(item) + 1 }}</span>
            </template>
            <template v-slot:item.valorPago="{ item }">
              <span>{{ util.IntegerToMoneyValueFatura(item.valorPago) }}</span>
            </template>
            <template v-slot:item.valorAPagar="{ item }">
              <span>{{ util.IntegerToMoneyValueFatura(item.valorAPagar) }}</span>
            </template>
            <template v-slot:no-data> Selecione a data inicial e a data final para visualizar os dados! </template>
          </v-data-table>
          <v-card-actions>
            <v-row v-if="dados.length">
              <v-col md="6"></v-col>
              <v-col md="3"><span style="font-weight:bold;">Total de Multas:</span><v-chip>0,00 Kz</v-chip></v-col>
              <v-col md="3"><span style="font-weight:bold;">Total Geral:</span><v-chip>{{ util.IntegerToMoneyValueFatura(total) }}</v-chip></v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </div>
    </div>
  </div>
</template>
<script>
import axios from '../../../plugins/axios';
import utilitarios from '../../../plugins/utilitarios';
import impressaoService from '../../../services/impressaoService';
const ls = require('local-storage')
import Swal from 'sweetalert2'

export default {
  data: () => ({
    bancoSelected: { nome: "", pk_banco: 0 },
    bancos: [],
    dados: [],
    date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    date2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    menu: false,
    menu2: null,
    util: utilitarios,
    headers: [
      { text: 'Nº de Ordem.', value: 'ordem' },
      { text: 'Emolumentos', value: 'produto' },
      { text: 'Quant.', value: 'qtd' },
      { text: 'Valor Pago', value: 'valorPago' },
      { text: 'I.V.A', value: 'iva' },
      { text: 'Total', value: 'valorPago' }
    ],
    searchInDb: '',
    dialog: false,
    overlay: false,
    ruleRequired: [value => !!value || 'campo obrigatorio'],
    config: null,
    baseUrl: '',
    templateFull: null
  }),

  computed: {
    licencaExpirada() {
      return ls.get('licencaExpirada')
    },
    total() {
      let total_ = 0
      this.dados.forEach(element => {
        total_ += element.valorPago
      });
      return total_
    }
  },

  created() {
    this.getBancos();
    this.config = ls.get('configuracaoinstituicao');
    this.getUrlImpressao();
    this.getTemplateRelatorio();
  },

  methods: {
    async getBancos() {
      this.overlay = true;
      try {
        this.bancos = await axios.get('bancoFindByInstituicao').then((res) => res.data);
      } catch (error) {
        utilitarios.showAlertMessage('warning', 'Ocorreu um erro ao carregar os seus dados.');
      } finally {
        this.overlay = false;
      }
    },

    async getTemplateRelatorio() {
      try {
        this.overlay = true;
        this.templateFull = await axios.get('/obterRelatorioByDescricao/bd').then((res) => res.data[0]);
      } catch (error) {
        utilitarios.showAlertMessage('warning', 'Ocorreu um erro durante o carregamento do pdf do relatório!');
      } finally {
        this.overlay = false;
      }
    },

    async getUrlImpressao() {
      this.overlay = true;
      try {
        this.baseUrl = await impressaoService.getBaseUrl().then((res) => res.data[0].url);
      } catch (error) {
        utilitarios.showAlertMessage('warning', 'Ocorreu um erro durante o carregamento do endereço do servidor de impressão!');
      } finally {
        this.overlay = false;
      }
    },

    async getVendas() {
      if (this.licencaExpirada) {
        Swal.fire('Informação', 'A sua licença de utilização encontra-se expirada! Por favor, entre em contato com o administrador do sistema!', 'info');
      } else {
        try {
          this.overlay = true;
          let params = {
            date1: this.date,
            date2: this.date2,
            pkBanco: this.bancoSelected.pk_banco
          }
          this.dados = await axios.post('VendasFindBancobydatesGroupByEmolumentos', params).then((res) => res.data)
        } catch (error) {
          utilitarios.showAlertMessage('warning', 'Ocorreu um erro ao carregar os seus dados.');
        } finally {
          this.overlay = false;
          if (this.dados.length === 0) {
            utilitarios.showAlertMessage('warning', 'Informação não encontrada.')
          } 
        }
      }
    },

    // Método responsavel por criar um HTML com os dados da coleção this.dados[]
    async gerarHTML() {
      try {
        this.$store.state.loading_pdf = true;

        let template = this.templateFull.documento;
        let relatorioDados = '';
        let c = 1;

        this.dados.forEach(element => {
          let interacao1 = this.templateFull.documentoiteracao1;
          interacao1 = interacao1.replace('{{index}}', c++);
          interacao1 = interacao1.replace('{{produto}}', element.produto);
          interacao1 = interacao1.replace('{{qtd}}', element.qtd);
          interacao1 = interacao1.replaceAll('{{valorPago}}', this.util.IntegerToMoneyValueFatura(element.valorPago));
          interacao1 = interacao1.replace('{{iva}}', this.util.IntegerToMoneyValueFatura(element.iva));
          
          relatorioDados += interacao1;
        })

        let dadoss = {
          '{{logoInstituicao}}': this.config.logo,
          '{{nomeInstituicao}}': this.config.nome,
          '{{dataInicial}}': this.date,
          '{{dataFinal}}': this.date2,
          '{{author}}': ls.get('nomeUsuario'),
          '{{dataActual}}': this.data_hora(),
          '{{totalGeral}}': this.util.IntegerToMoneyValueFatura(this.total),
          '{{dados}}': relatorioDados,
          '{{nomeBanco}}': this.bancoSelected.nome,
        }

        const expressaoRegular = new RegExp(Object.keys(dadoss).join("|"), "g");
        template = template.replace(expressaoRegular, (match) => dadoss[match]);

            let options = {
              'format': 'A4',
              'border': {'right': '9mm', 'left': '9mm'},
              'header': {'height': '10mm'},
              'footer': {'height': '1mm'}
            }
            impressaoService.htmlToPdf(template, options);
      } catch (error) {
        this.$store.state.loading_pdf = false;
        utilitarios.showAlertMessage('warning', 'Ocorreu um erro durante a impressão do documento.');
      }
    },

    // Método responsavél por guardar a data atual
    data_hora() {
      let data = new Date()
      return data.getDate() + '/' + (data.getMonth() + 1) + '/' + (data.getFullYear()) + ' ' + (data.getHours()) + ':' + (data.getMinutes()) + ':' + (data.getSeconds())
    }
  }
}
</script>
<style scoped></style>
